<template>
  <v-container>
    <v-btn class="ma-2 ml-8" color="secondary" to="/admin/kegiatan/khotib">
      <v-icon left> mdi-arrow-left </v-icon>
      Kembali
    </v-btn>
    <form v-on:keyup.enter="submit" class="pa-4">
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Form Petugas Sholat Jumat</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="mr-3">
              <v-text-field
                outlined
                label="Nama Khotib"
                v-model.trim="$v.khatib.$model"
                :error-messages="khatibError"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined label="Nama Muadzin" v-model="muadzin">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-3">
              <v-text-field
                outlined
                label="Judul Khotbah"
                v-model="materi_khutbah"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-menu :close-on-content-click="true" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="!date ? '' : formatDate(date)"
                    outlined
                    clearable
                    label="Tanggal Pelaksanaan"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="date = null"
                    :error-messages="dateError"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="$v.date.$model"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-btn color="primary" @click="submit">Submit</v-btn>
        </v-card-text>
      </v-card>
    </form>

    <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
      "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
      bagaimana kita memperbaikinya" <br />
      -Admin
    </p>

    <p v-if="isCreateError" class="mt-2 red--text text-caption error-caption">
      Maaf, terjadi kesalahan saat mendaftarkan khatib, mohon ulangi daftar
      kembali. ^^
    </p>
  </v-container>
</template>

<script>
import router from "../../router";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      date: "",
      khatib: "",
      muadzin: "",
      materi_khutbah: "",
      isFormError: false,
      isCreateError: false,
    };
  },
  validations: {
    date: {
      required,
    },
    khatib: {
      required,
      minLength: minLength(3),
    },
  },
  computed: {
    khatibError() {
      const errors = [];
      if (!this.$v.khatib.$dirty) return errors;
      !this.$v.khatib.minLength &&
        errors.push("Nama Khatib minimal 3 huruf");
      !this.$v.khatib.required &&
        errors.push("Nama Khatib tidak boleh kosong");
      return errors;
    },
    dateError() {
      const errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required &&
        errors.push("Tanggal tidak boleh kosong");
      return errors;
    },
  },
  methods: {
    formatDate(targetDate) {
      return this.$moment(targetDate).format("D MMMM YYYY");
    },
    submit() {
      let masjidUid = localStorage.getItem("masjid");

      this.$v.$touch();
      if (this.$v.khatib.$invalid || this.$v.date.$invalid) {
        this.isFormError = true;
      } else {
        this.axios
          .post("/masjid/soljum", {
            date: this.date,
            khatib: this.khatib,
            muadzin: this.muadzin,
            materi_khutbah: this.materi_khutbah,
            masjid_uid: masjidUid,
          })
          .then((response) => {
            console.log(response);
            this.isCreateError = false;
            this.isFormError = false;
            router.push("/admin/kegiatan/khotib");
          })
          .catch((error) => {
            this.isCreateError = true;
            console.log(error);
          });
      }
    },
  },
};
</script>

<style>
</style>